Vue.component('ppcarto-drawer', {
  template: `
    <div class="ppcarto-drawer">
      <div v-for="section in selected" v-bind:class="['drawer', section.key ? section.key : '']" @click="switchTo(section)">
        <div>+{{section.name}}</div><a href="#" @click.prevent="deselect(section)">CLOSE</a>
      </div>
    </div>
  `,

  data: function (){
    {}
  },

  computed: {
    selected () {
      let history = this.$store.getters.getHistory;
      return history.slice(0,-1);
    }
  },

  methods: {
    deselect(item) {
      if(item.action) {
        this.$store.commit('toggleAction', item)
      } else {
        this.$store.commit('toggleSection', item)
      }
    },
    switchTo(item) {
      this.$store.commit('switchTo', item.key);
    }
  },

  mounted () {
    //console.dir(this.selected);
  }

});
